import { Action, AnyAction } from '../action.type';
import { AppState } from '../app.state';
import {
  RetrieveGlobalTournamentDetailsSuccessPayload,
  RetrieveTournamentDetailsSuccessPayload,
  RetrieveTournamentsByUserSuccessPayload,
  RetrieveTournamentsCreatedByUserSuccessPayload,
  RetrieveTournamentsSuccessPayload,
  RETRIEVE_GLOBAL_TOURNAMENT_DETAILS,
  RETRIEVE_GLOBAL_TOURNAMENT_DETAILS_FAILURE,
  RETRIEVE_GLOBAL_TOURNAMENT_DETAILS_SUCCESS,
  RETRIEVE_TOURNAMENTS,
  RETRIEVE_TOURNAMENTS_BY_USER,
  RETRIEVE_TOURNAMENTS_BY_USER_FAILURE,
  RETRIEVE_TOURNAMENTS_BY_USER_SUCCESS,
  RETRIEVE_TOURNAMENTS_CREATED_BY_USER,
  RETRIEVE_TOURNAMENTS_CREATED_BY_USER_FAILURE,
  RETRIEVE_TOURNAMENTS_CREATED_BY_USER_SUCCESS,
  RETRIEVE_TOURNAMENTS_FAILURE,
  RETRIEVE_TOURNAMENTS_SUCCESS,
  RETRIEVE_TOURNAMENT_DETAILS,
  RETRIEVE_TOURNAMENT_DETAILS_FAILURE,
  RETRIEVE_TOURNAMENT_DETAILS_SUCCESS,
} from './tournament.action.type';

export const tournamentReducer = (
  state: AppState,
  action: AnyAction,
): AppState => {
  switch (action.type) {
    case RETRIEVE_TOURNAMENTS:
      return retrieveTournamentsReducer(state);
    case RETRIEVE_TOURNAMENTS_SUCCESS:
      return retrieveTournamentsSuccessReducer(state, action);
    case RETRIEVE_TOURNAMENTS_FAILURE:
      return retrieveTournamentsFailureReducer(state, action);
    case RETRIEVE_TOURNAMENTS_BY_USER:
      return retrieveTournamentsByUserReducer(state);
    case RETRIEVE_TOURNAMENTS_BY_USER_SUCCESS:
      return retrieveTournamentsByUserSuccessReducer(state, action);
    case RETRIEVE_TOURNAMENTS_BY_USER_FAILURE:
      return retrieveTournamentsByUserFailureReducer(state, action);
    case RETRIEVE_TOURNAMENTS_CREATED_BY_USER:
      return retrieveTournamentsCreatedByUserReducer(state);
    case RETRIEVE_TOURNAMENTS_CREATED_BY_USER_SUCCESS:
      return retrieveTournamentsCreatedByUserSuccessReducer(state, action);
    case RETRIEVE_TOURNAMENTS_CREATED_BY_USER_FAILURE:
      return retrieveTournamentsCreatedByUserFailureReducer(state, action);
    case RETRIEVE_TOURNAMENT_DETAILS:
      return retrieveTournamentDetailsReducer(state);
    case RETRIEVE_TOURNAMENT_DETAILS_SUCCESS:
      return retrieveTournamentDetailsSuccessReducer(state, action);
    case RETRIEVE_TOURNAMENT_DETAILS_FAILURE:
      return retrieveTournamentDetailsFailureReducer(state, action);
    case RETRIEVE_GLOBAL_TOURNAMENT_DETAILS:
      return retrieveGlobalTournamentDetailsReducer(state);
    case RETRIEVE_GLOBAL_TOURNAMENT_DETAILS_SUCCESS:
      return retrieveGlobalTournamentDetailsSuccessReducer(state, action);
    case RETRIEVE_GLOBAL_TOURNAMENT_DETAILS_FAILURE:
      return retrieveGlobalTournamentDetailsFailureReducer(state, action);
    default:
      return state;
  }
};

const retrieveTournamentsReducer = (state: AppState): AppState => {
  return {
    ...state,
    tournament: {
      ...state.tournament,
      isTournamentLoading: true,
    },
  };
};

const retrieveTournamentsSuccessReducer = (
  state: AppState,
  action: Action<RetrieveTournamentsSuccessPayload>,
): AppState => {
  return {
    ...state,
    tournament: {
      ...state.tournament,
      isTournamentLoading: false,
      tournaments: action.payload.tournaments,
    },
  };
};

const retrieveTournamentsFailureReducer = (
  state: AppState,
  action: Action<string>,
): AppState => {
  return {
    ...state,
    tournament: {
      ...state.tournament,
      isTournamentLoading: false,
      error: action.payload,
    },
  };
};

const retrieveTournamentsByUserReducer = (state: AppState): AppState => {
  return {
    ...state,
    tournament: {
      ...state.tournament,
      isUserTournamentLoading: true,
    },
  };
};

const retrieveTournamentsByUserSuccessReducer = (
  state: AppState,
  action: Action<RetrieveTournamentsByUserSuccessPayload>,
): AppState => {
  return {
    ...state,
    tournament: {
      ...state.tournament,
      isUserTournamentLoading: false,
      userTournaments: action.payload.userTournaments,
    },
  };
};

const retrieveTournamentsByUserFailureReducer = (
  state: AppState,
  action: Action<string>,
): AppState => {
  return {
    ...state,
    tournament: {
      ...state.tournament,
      isUserTournamentLoading: false,
      error: action.payload,
    },
  };
};

const retrieveTournamentsCreatedByUserReducer = (state: AppState): AppState => {
  return {
    ...state,
    tournament: {
      ...state.tournament,
      isUserCreatedTournamentLoading: true,
    },
  };
};

const retrieveTournamentsCreatedByUserSuccessReducer = (
  state: AppState,
  action: Action<RetrieveTournamentsCreatedByUserSuccessPayload>,
): AppState => {
  return {
    ...state,
    tournament: {
      ...state.tournament,
      isUserCreatedTournamentLoading: false,
      userCreatedTournaments: action.payload.userTournaments,
    },
  };
};

const retrieveTournamentsCreatedByUserFailureReducer = (
  state: AppState,
  action: Action<string>,
): AppState => {
  return {
    ...state,
    tournament: {
      ...state.tournament,
      isUserCreatedTournamentLoading: false,
      error: action.payload,
    },
  };
};

const retrieveTournamentDetailsReducer = (state: AppState): AppState => {
  return {
    ...state,
    tournament: {
      ...state.tournament,
      isTournamentDetailsLoading: true,
    },
  };
};

const retrieveTournamentDetailsSuccessReducer = (
  state: AppState,
  action: Action<RetrieveTournamentDetailsSuccessPayload>,
): AppState => {
  return {
    ...state,
    tournament: {
      ...state.tournament,
      isTournamentDetailsLoading: false,
      tournamentDetails: action.payload.tournamentDetails,
    },
  };
};

const retrieveTournamentDetailsFailureReducer = (
  state: AppState,
  action: Action<string>,
): AppState => {
  return {
    ...state,
    tournament: {
      ...state.tournament,
      isTournamentDetailsLoading: false,
      error: action.payload,
    },
  };
};

const retrieveGlobalTournamentDetailsReducer = (state: AppState): AppState => {
  return {
    ...state,
    tournament: {
      ...state.tournament,
      isTournamentDetailsLoading: true,
    },
  };
};

const retrieveGlobalTournamentDetailsSuccessReducer = (
  state: AppState,
  action: Action<RetrieveGlobalTournamentDetailsSuccessPayload>,
): AppState => {
  return {
    ...state,
    tournament: {
      ...state.tournament,
      isTournamentDetailsLoading: false,
      tournamentDetails: action.payload.tournamentDetails,
    },
  };
};

const retrieveGlobalTournamentDetailsFailureReducer = (
  state: AppState,
  action: Action<string>,
): AppState => {
  return {
    ...state,
    tournament: {
      ...state.tournament,
      isTournamentDetailsLoading: false,
      error: action.payload,
    },
  };
};
